module.exports = new __parcel__URL__("Mageskill_09.a357473f.png").toString();